var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { colors, fontSizes, fontWeights, spacing, } from "syf-component-library/defaultTheme";
export var COLORS = __assign(__assign({}, colors), { fontDefault: "#232323", lightBorder: "#f2f2f2", lightestCyanBlue: "#34657f1a", lightCyanBlue: "#34657f33", lightBlack: "#4c4c4c" });
export var FONT_SIZES = __assign({ smallest: 10, smallRoot: 14 }, fontSizes);
export var FONT_WEIGHTS = __assign({}, fontWeights);
export var SPACING = __assign({ mediumSmall: 6, smallMedium: 10, smallBase: 14, xxxlarge: 44 }, spacing);
//# sourceMappingURL=baseTheme.js.map